export const getAuthErrorMessage = async (response: Response, fallback: string): Promise<string> => {
  try {
    const errorBody: unknown = await response.json();
    if (
      typeof errorBody === 'object' &&
      errorBody !== null &&
      'message' in errorBody &&
      typeof errorBody.message === 'string' &&
      errorBody.message
    ) {
      return errorBody.message;
    }
  } catch {
    return fallback;
  }

  return fallback;
};
